import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { DropdownButton } from 'react-bootstrap';
//let PureRenderMixin from 'react-addons-pure-render-mixin';

import GlyphiconButton from './GlyphiconButton';

class AttributeEditWidget extends React.Component {
    
    constructor(props, context) {
        super(props, context);

        this.state = {
            edit: this.props.edit,
            name: this.props.edit ? this.props.attribute.name : "",
            required: this.props.edit ? this.props.attribute.required : false,

            typeOptions: ["Checkbox", "Combobox", "Date", "Text"],
            typeStatus: "Type"
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            edit: nextProps.edit,
            name: nextProps.edit ? nextProps.attribute.name : "",
            required: nextProps.edit ? nextProps.attribute.required : false
        });
    }

    // EVENT HANDLERS

    // passed as props
    handleCancel = () => {

    }

    handleChecked = () => {
        this.setState({
            required: !this.state.required
        });
    }

    handleNameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    }

    // passed as props
    handleSave = () => {

    }

    // TODO : required by MenuItem ? nigdje nije postavljeno niti se prenosi preko propsa
    handleTypeSelect = () => {

    }

    // RENDER METHOD

    render = () => {
        return (
            <Panel header={this.props.header}>
                <Input   type="textarea"
                            style={{height: '40px', resize: 'vertical'}}
                            value={this.state.name}
                            onChange={this.handleNameChange}
                            placeholder="Attribute name"
                            />
                <br/>
                <Row>
                    <Col md={5} mdOffset={1}>
                        <DropdownButton id="attributeEditWidgetDropdownButton" style={{width: '100%', 'marginLeft': '70px'}} title={this.state.typeStatus}>
                        {
                            this.state.typeOptions.map((text, key) => {
                                return <MenuItem key={key} id={key} onSelect={this.handleTypeSelect} style={{width: '100%'}}>{text}</MenuItem>;
                            })
                        }
                        </DropdownButton>
                    </Col>
                    <Col md={1} mdOffset={2}>
                        <Input   type="checkbox"
                                    checked={this.state.required}
                                    onChange={this.handleChecked}
                                    label="Required"
                                    />
                    </Col>
                </Row>

                <br/>
                <Row>
                    <Col md={6}>
                        <GlyphiconButton classNames={["add-button"]} handleClick={this.handleSave} name="floppy-disk"/>
                    </Col>
                    <Col md={6}>
                        <GlyphiconButton classNames={["add-button"]} handleClick={this.props.handleCancel} name="remove"/>
                    </Col>
                </Row>
            </Panel>
        );
    }
}

AttributeEditWidget.propTypes = {
    header: PropTypes.object,
    edit: PropTypes.bool,
    attribute: PropTypes.object,
    handleSave: PropTypes.func,
    handleCancel: PropTypes.func
};

AttributeEditWidget.defaultProps = {
    edit: false,
    name: "",
    required: false
};

export default connect()(AttributeEditWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/AttributeEditWidget.js
 **/